var ii_iphonexssnap = "google-min-cover.png";
var ii_iphonexsmaxsnap = "i_ipxsmxsp.jpg";

var ii_googlepixelxl = "Google-Pixel-Case-xs.png";

var ii_iphone12miniimpactblack = "iphone12impact.png";
var ii_iphone12miniimpactwhite = "iphone12impact.png";
var ii_iphone12miniimpactpink = "iphone12impact.png";
var ii_iphone12minitoughclearedges = "iphone12toughclearedges.png";
var ii_iphone12minisnapclearedges = "iphone12snapclearedges.png";

var ii_iphone12promaximpactblack = "iphone12promaximpact.png";
var ii_iphone12promaximpactwhite = "iphone12promaximpact.png";
var ii_iphone12promaximpactpink = "iphone12promaximpact.png";
var ii_iphone12promaxtoughclearedges = "iphone12promaxtoughclearedges.png";
var ii_iphone12promaxsnapclearedges = "iphone12promaxsnapclearedges.png";

var ii_iphone12proimpactblack = "iphone12proimpact.png";
var ii_iphone12proimpactwhite = "iphone12proimpact.png";
var ii_iphone12proimpactpink = "iphone12proimpact.png";
var ii_iphone12protoughclearedges = "iphone12protoughclearedges.png";
var ii_iphone12prosnapclearedges = "iphone12prosnapclearedges.png";

var ii_iphone12impactblack = "iphone12impact.png";
var ii_iphone12impactwhite = "iphone12impact.png";
var ii_iphone12impactpink = "iphone12impact.png";
var ii_iphone12toughclearedges = "iphone12toughclearedges.png";
var ii_iphone12snapclearedges = "iphone12snapclearedges.png";

var ii_iphonese2020toughclearedges = "iphonese2020toughclearedges.png";
var ii_iphonese2020snapclearedges = "iphonese2020snapclearedges.png";

var ii_iphone11promaximpactblack = "iphone12miniimpact.png";
var ii_iphone11promaximpactwhite = "iphone12miniimpact.png";
var ii_iphone11promaximpactpink = "iphone12miniimpact.png";
var ii_iphone11promaxtoughclearedges = "iphone12promaxtoughclearedges.png";
var ii_iphone11promaxsnapclearedges = "iphone12promaxsnapclearedges.png";

var ii_iphone11proimpactblack = "iphone12miniimpact.png";
var ii_iphone11proimpactwhite = "iphone12miniimpact.png";
var ii_iphone11proimpactpink = "iphone12miniimpact.png";
var ii_iphone11protoughclearedges = "iphone12protoughclearedges.png";
var ii_iphone11prosnapclearedges = "iphone12prosnapclearedges.png";

var ii_iphone11impactblack = "iphone12impact.png";
var ii_iphone11impactwhite = "iphone12impact.png";
var ii_iphone11impactpink = "iphone12impact.png";
var ii_iphone11toughclearedges = "iphone12toughclearedges.png";
var ii_iphone11snapclearedges = "iphone12snapclearedges.png";

var ii_iphonexsimpactblack = "iphonexsimpact.png";
var ii_iphonexsimpactwhite = "iphonexsimpact.png";
var ii_iphonexsimpactpink = "iphonexsimpact.png";
var ii_iphonexstoughclearedges = "iphonexstoughclearedges.png";
var ii_iphonexssnapclearedges = "iphonexssnapclearedges.png";

var ii_iphonexsmaximpactblack = "iphonexsmaximpact.png";
var ii_iphonexsmaximpactwhite = "iphonexsmaximpact.png";
var ii_iphonexsmaximpactpink = "iphonexsmaximpact.png";
var ii_iphonexsmaxtoughclearedges = "iphonexstoughclearedge.png";
var ii_iphonexsmaxsnapclearedges = "iphonexsmaxsnapclearedges.png";

var ii_iphonexrimpactblack = "iphonexrimpact.png";
var ii_iphonexrimpactwhite = "iphonexrimpact.png";
var ii_iphonexrimpactpink = "iphonexrimpact.png";
var ii_iphonexrtoughclearedges = "iphonexstoughclearedges.png";
var ii_iphonexrsnapclearedges = "iphonexrsnapclearedges.png";

var ii_iphoneximpactblack = "iphonexsimpact.png";
var ii_iphoneximpactwhite = "iphonexsimpact.png";
var ii_iphoneximpactpink = "iphonexsimpact.png";
var ii_iphonextoughclearedges = "iphonexstoughclearedges.png";
var ii_iphonexsnapclearedges = "iphonexssnapclearedges.png";

var ii_iphone8toughclearedges = "iphone8toughclearedges.png";
var ii_iphone8snapclearedges = "iphone8snapclearedges.png";

var ii_iphone8plustoughclearedges = "iphone8plustoughclearedges.png";
var ii_iphone8plussnapclearedges = "iphone8plussnapclearedges.png";

var ii_iphone7toughclearedges = "iphone7toughclearedges.png";
var ii_iphone7snapclearedges = "iphone8snapclearedges.png";

var ii_iphone7plustoughclearedges = "iphone7plustoughclearedges.png";
var ii_iphone7plussnapclearedges = "iphone8plussnapclearedges.png";

var ii_iphone66stoughclearedges = "iphone7toughclearedges.png";
var ii_iphone66ssnapclearedges = "iphone66ssnapclearedges.png";

var ii_iphone6plus6splustoughclearedges = "iphone7plustoughclearedges.png";
var ii_iphone6plus6splussnapclearedges = "iphone6plus6splussnapclearedges.png";

var ii_iphone55sSEsnapclearedges = "iphone55sSEsnapclearedges.png";

var ii_iphone5csnapclearedges = "iphone5csnapclearedges.png";

var ii_iphone44ssnapclearedges = "iphone44ssnapclearedges.png";

var ii_keyring = "i_keyring.jpg";
var ii_cardholderblcroc = "i_cardholderblcroc.png";
var ii_cardholderblsaf = "i_cardholderblsaf.png";
var ii_cardholdercaramel = "i_cardholdercaramel.png";
var ii_cardholderpinkcroc = "i_cardholderpinkcroc.png";
var ii_cardholderwhcroc = "i_cardholderwhcroc.png";
var ii_toteblcroc = "i_toteblcroc.png";
var ii_toteblsaf = "i_toteblsaf.png";
var ii_halfmoonpinkcrcoc = "i_halfmoonpinkcrcoc.png";
var ii_halfmoonblsaf = "i_halfmoonblsaf.png";
var ii_halfmoonblsmooth = "i_halfmoonblsmooth.png";
var ii_halfmoonblcroc = "i_halfmoonblcroc.png";
var ii_circleblcroc = "i_circleblcroc.png";
var ii_circlepinkcroc = "i_circlepinkcroc.png";
var ii_circleblsaff = "i_circleblsaff.png";
var ii_maskblaksaffcarduv = "i_maskblaksaffcarduv.png";
var ii_maskcaramelcarduv = "i_maskcaramelcarduv.png";
var ii_halfmooncaramelsmooth = "i_halfmooncaramelsmooth.png";
var ii_passportpinkpython = "i_passportpinkpython.png";
var ii_cardholderpinkpython = "i_cardholderpinkpython.png";
var ii_luggagetagpinkpython = "i_luggagetagpinkpython.png";

var ii_iphonexs = "iphone-xs-leather-back.png";
var ii_iphonexsmax = "iphone-xs-max-leather-back.png";
var ii_iphonexr = "iphone-xr-leather-back.png";
var ii_iphonex = "iphone-xs-leather-back.png";
var ii_iphone8 = "iphone-6-leather-back.png";
var ii_iphone8plus = "iphone-6p-leather-back.png";
var ii_iphone7 = "iphone-6-leather-back.png";
var ii_iphone7plus = "iphone-6p-leather-back.png";
var ii_iphone66s = "iphone-6-leather-back.png";
var ii_iphone6plus6splus = "iphone-6p-leather-back.png";
var ii_iphone55s = "iphone-5-leather-back.png";
var ii_samsunggalaxys9 = "samsung-s9-leather-back.png";
var ii_samsunggalaxys9s9plus = "samsung-s9p-leather-back.png";
var ii_pouch = "pouches-back.png";
var ii_iphone11 = "iphone-xs-leather-back.png";
var ii_iphone11pro = "iphone-xs-leather-back.png";
var ii_iphone11promax = "iphone-xs-leather-back.png";
var ii_samsunggalaxys10 = "samsung-s9-leather-back.png";
var ii_samsunggalaxys10plus = "samsung-s9-leather-back.png";
var ii_samsunggalaxys10e = "samsung-s9-leather-back.png";
var ii_iphonese2020 = "iphone-6-leather-back.png";
var ii_iphone12mini = "iphone-xs-leather-back.png";
var ii_iphone12promax = "iphone-xs-leather-back.png";
var ii_iphone12pro = "iphone-xs-leather-back.png";
var ii_iphone12 = "iphone-xs-leather-back.png";
var ii_s20 = "samsung-s9-leather-back.png";
var ii_s20plus = "samsung-s9-leather-back.png";
var ii_s20ultra = "samsung-s9-leather-back.png";